import { ODListableResponseType } from '@mdpp/od-react-belt'
import React from 'react'
import { GQLPharmacyHasHospital } from '@mdpp/common/lib/@types/server.schema'
import { useAdminAPIs } from '../../context/useAdminAPIs'
import { IPharmacyHasHospitalOptions } from '../AdminPharmacyHasHospitalCommon'

export function usePharmacyHasHospitalListDataLoader(hospitalId?: number) {
  const { listPharmacyHasHospital } = useAdminAPIs()

  return React.useCallback(
    async function dataLoader(
      page: number,
      pageSize: number,
      afterKey: string | null,
      options: IPharmacyHasHospitalOptions
    ): Promise<ODListableResponseType<GQLPharmacyHasHospital>> {
      const { hospitalId: ignoreThis, ...rest } = options
      const r = await listPharmacyHasHospital({
        page,
        pageSize,
        hospitalId: hospitalId ?? null,
        ...rest,
      })

      return r as ODListableResponseType<GQLPharmacyHasHospital>
    },
    [listPharmacyHasHospital, hospitalId]
  )
}
